import styled, { css } from "styled-components";

export const Container = styled.div`
  background-color: #7b6e661a;
  padding: 20px 20%;

  @media screen and (max-width: 768px) {
    padding: 20px;
  }
`;

export const LinkContainer = styled.div`
  transition: all 300ms;
  &:hover {
    transform: scale(1.05);
  }

  @media screen and (max-width: 768px) {
    &:hover {
      transform: none;
    }
  }
`;
